/* cáene Mugler-preview — R06 manuella kundcitat.
   Ägs av sections/caene-customer-quotes.liquid. Fristående fil, inga beroenden
   och ingen extern tjänst.

   Elementet definieras en gång, och connectedCallback river alltid en tidigare
   uppsättning lyssnare först. Omladdning i temaeditorn är därför ofarlig.

   Progressiv förbättring: markupen visar alla citat och håller prickarna dolda.
   Först här staplas citaten och prickarna tas fram. Ingen autoplay, ingen timer
   och ingen rörelse — därför behövs ingen reduced motion-hantering. */
if (!customElements.get('caene-customer-quotes')) {
  customElements.define(
    'caene-customer-quotes',
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();

        const slidesEl = this.querySelector('.caene-quotes__slides');
        const dotsEl = this.querySelector('.caene-quotes__dots');
        const slides = Array.from(this.querySelectorAll('.caene-quotes__slide'));
        const dots = Array.from(this.querySelectorAll('.caene-quotes__dot'));

        // Ett ensamt citat behöver ingen växling, och en ojämn uppsättning
        // prickar vore ett byggfel som inte ska döljas av skriptet.
        if (!slidesEl || !dotsEl || slides.length < 2) return;
        if (dots.length !== slides.length) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;

        slidesEl.classList.add('caene-quotes__slides--single');
        dotsEl.hidden = false;
        this.index = 0;

        const alignArrows = () => {
          const quote = slides[this.index]?.querySelector('.caene-quotes__quote');
          if (!quote) return;
          const rect = quote.getBoundingClientRect();
          this.style.setProperty('--quote-mid', `${rect.top - this.getBoundingClientRect().top + rect.height / 2}px`);
        };

        const show = (wanted, moveFocus) => {
          const index = (wanted + slides.length) % slides.length;
          slides.forEach((slide, n) => {
            const active = n === index;
            slide.dataset.active = active ? 'true' : 'false';
            if (active) {
              slide.removeAttribute('inert');
            } else {
              slide.setAttribute('inert', '');
            }
          });
          dots.forEach((dot, n) => {
            dot.setAttribute('aria-pressed', n === index ? 'true' : 'false');
          });
          this.index = index;
          alignArrows();
          if (moveFocus) dots[index].focus();
        };

        this.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => show(this.index + Number(button.dataset.direction)), { signal });
        });

        dots.forEach((dot, n) => {
          dot.addEventListener('click', () => show(n), { signal });
        });

        // Vänster och höger pil flyttar valet när fokus står på prickarna.
        // Fokus följer med, annars tappar tangentbordet kontakten med det citat
        // som faktiskt visas.
        dotsEl.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          },
          { signal }
        );

        // Temaeditorn: klick på ett block i sidopanelen ska visa just det
        // citatet. Händelsen bubblar från elementet som bär shopify_attributes.
        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const slide = event.target.closest('.caene-quotes__slide');
            if (!slide) return;
            const index = slides.indexOf(slide);
            if (index > -1) show(index);
          },
          { signal }
        );

        this.resizeObserver = new ResizeObserver(alignArrows);
        slides.forEach((slide) => this.resizeObserver.observe(slide));
        show(0);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    }
  );
}
